import React, { useState, useEffect } from "react";

import { Modal, message } from "antd";
import Descripciongeneral from "./componentesPdf/Descripciongeneral";
import eventService from "../../../services/eventService";
import DescripcionProtocolo from "./componentesPdf/DescripcionProtocolo";
import Loading from "../../layouts/Loading";
import EjemploPdf from "./componentesPdf/EjemploPdf";
import { useUser } from "../../../context/UserContext";
import userService from "../../../services/UserService";

export default function ModalInformePDF({ open, setOpen, item }) {
  const [loadingPDF, setLoadingPDF] = useState(true);
  const [infoEvent, setInfoEvent] = useState(null);
  const [userv1, setUserv1] = useState(null);
  const [userv2, setUserv2] = useState(null);
  const [usuariosCombinados, setUsuariosCombinados] = useState([]);
  const user = useUser();

  // Función para unir las tablas userv1 y userv2 solo con id y email
  const combinarUsuarios = (v1, v2) => {
    if (!v1 || !v2) return [];

    const usuariosUnidos = [];

    // Agregar usuarios de v1
    v1.forEach((user) => {
      if (user.id && user.email) {
        usuariosUnidos.push({
          id: user.id,
          email: user.email,
          name: user.name,
          lastName: user.lastName,
          source: "v1",
        });
      }
    });

    // Agregar usuarios de v2 (evitando duplicados por ID)
    v2.forEach((user) => {
      if (user.id && user.email) {
        const existe = usuariosUnidos.find((u) => u.id === user.id);
        if (!existe) {
          usuariosUnidos.push({
            id: user.id,
            email: user.email,
            name: user.name,
            lastName: user.lastName,
            source: "v2",
          });
        }
      }
    });

    return usuariosUnidos;
  };

  const consultaReportes = async () => {
    setLoadingPDF(true);
    try {
      const response = await eventService.consultarReportes(
        item.id,
        user?.idToken || ""
      );

      let data = response.Item;
      setInfoEvent(data);
      setLoadingPDF(false);
    } catch (error) {
      message.error("No se logro hacer la consulta");
      setLoadingPDF("error");
    }
  };

  const consultaUsuario_v2 = async () => {
    try {
      const response = await userService.consultarUsuarios(user?.idToken || "");

      let data = response.Items;
      setUserv2(data);
    } catch (error) {
      message.error("No se logro hacer la consulta");
      setLoadingPDF("error");
    }
  };

  const consultaUsuario_v1 = async () => {
    try {
      const usuariosData = await userService.consultarUsuarios_v1(
        user?.idToken || ""
      );

      let data = usuariosData.response.Items;
      setUserv1(data);
    } catch (error) {
      message.error("No se logro hacer la consulta");
      setLoadingPDF("error");
    }
  };

  useEffect(() => {
    if (open) {
      consultaUsuario_v2();
      consultaUsuario_v1();
      consultaReportes();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Efecto para combinar usuarios cuando se actualicen las tablas
  useEffect(() => {
    if (userv1 && userv2) {
      const usuariosUnidos = combinarUsuarios(userv1, userv2);
      setUsuariosCombinados(usuariosUnidos);
    }
  }, [userv1, userv2]);

  return (
    <>
      {open && (
        <Modal
          open={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          footer={null}
          width="85vw"
          style={{ top: 20 }}
          bodyStyle={{
            maxHeight: "90vh",
            overflow: "hidden",
            padding: "12px",
          }}
        >
          <div className="pdf-modal-container">
            {!loadingPDF && (
              <>
                <EjemploPdf
                  itemsGeneral={infoEvent}
                  users={usuariosCombinados}
                />
                <div className="pdf-scrollable-content">
                  {infoEvent ? (
                    <>
                      {/* Página principal con información general */}
                      <div className="pdf-page-container" id="paginaPincipal">
                        <div className="pdf-page-content">
                          <div className="pdf-page-overflow">
                            {/* 
                              Pasar la función getUserById a Descripciongeneral si necesita mostrar emails de usuarios
                              Ejemplo: <Descripciongeneral item={infoEvent} getUserById={getUserById} />
                            */}
                            <Descripciongeneral
                              item={infoEvent}
                              users={usuariosCombinados}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Contenedor único para todos los protocolos que permite paginación automática */}
                      <div className="pdf-protocols-container">
                        {infoEvent.protocols.map((objeto, index) => (
                          <div
                            key={index}
                            className="pdf-protocol-section"
                            id={`protocolo${index}`}
                          >
                            {/* 
                              Pasar la función getUserById a DescripcionProtocolo si necesita mostrar emails de usuarios
                              Ejemplo: <DescripcionProtocolo itemProtocol={objeto} getUserById={getUserById} />
                            */}
                            <DescripcionProtocolo
                              itemProtocol={objeto}
                              users={usuariosCombinados}
                              causes={infoEvent.causes}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            )}

            {loadingPDF && <Loading />}
            {loadingPDF === "error" && <Loading />}
          </div>
        </Modal>
      )}
    </>
  );
}
